/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:52:41 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 09:52:41 
 */
import { getJson, post, put } from '.';

/**
 * @function getNoticeList
 * @desc 获取公告
 * @param {string} webcastId 直播id
 * @returns {Promise}
 */
export const getNoticeList = (webcastId) =>
  getJson(`${config.cpp}handler/v2/noticeV2/get/info`, { webcastId });

/**
 * @function noticePublish
 * @desc 发布公告
 * @param {number} params.mode 发布模式 0 单条,1多条
 * @param {string} params.state 0 发布,1不发布
 * @param {string} params.title 公告内容
 * @param {string} params.webcastId 直播id
 * @returns {Promise}
 */
export const noticeAdd = (params) =>
  post(`${config.cpp}handler/v2/noticeV2/add`, params)

/**
 * @function noticeMode
 * @desc 修改公告模式
 * @param {number} params.mode 发布模式 0 单条,1多条
 * @param {string} params.webcastId 直播id
 * @returns {Promise}
 */
export const noticeMode = (params) =>
  put(`${config.cpp}handler/v2/noticeV2/update/mode`, params)

/**
 * @function noticePublish
 * @desc 发布公告
 * @param {string} params.noticeId 公告id
 * @param {string} params.webcastId 直播id
 * @returns {Promise}
 */
export const noticePublish = (params) =>
  post(`${config.cpp}handler/v2/noticeV2/publish`, params)


/**
 * @function noticeCancel
 * @desc 取消公告
 * @param {number} params.noticeId 公告id
 * @param {string} params.webcastId 直播id
 * @returns {Promise}
 */
export const noticeCancel = (params) =>
  post(`${config.cpp}handler/v2/noticeV2/cancel`, params)